import httpRequest from '@/api/request'
import { I_BlockData, I_BlockDataDetail, ResponseData, TransactionDataList } from './interface'

/**
 *
 * @limit pageSize
 * @offset pageNum 从便宜量0开始
 * @returns
 */
export const getRestBlockList = ({
  limit = 10,
  offset = 0,
  key,
}: {
  limit: number
  offset: number
  key?: number
}): Promise<I_BlockData> => {
  return httpRequest.get('/api/block/list', { params: { limit, offset, key } })
}

/**
 * 区块详情 detail
 * @param params
 * @returns
 */
export const getRestBlockDetail = (params: { height: number }): Promise<I_BlockDataDetail> => {
  return httpRequest.get('/api/rest/block/detail', { params })
}

/**
 * 区块详情 detail 日志
 * @param params
 * @returns
 */
export const getRestBlockRawLog = (params: { height: number }): Promise<{ [key: string]: any }> => {
  return httpRequest.get('/api/rest/block/raw_log', { params })
}

/**
 * 区块内交易列表 txs
 * @limit pageSize
 * @offset pageNum 从便宜量0开始
 * @height 区块高度
 * @returns
 */
export const getRestBlockTxs = ({
  limit = 10,
  offset = 0,
  height,
}: {
  limit: number
  offset: number
  height: number
}): Promise<TransactionDataList> => {
  return httpRequest.get('/api/rest/block/txs', { params: { limit, offset, height } })
}

/**
 * 区块内交易列表 txs
 * @limit pageSize
 * @offset pageNum 从便宜量0开始
 * @height 区块高度
 * @returns
 */
export const getRestBlockModuleTransfers = ({
  limit = 10,
  offset = 0,
  height,
}: {
  limit: number
  offset: number
  height: number
}): Promise<ResponseData> => {
  return httpRequest.get('/api/rest/block/module-transfers', { params: { limit, offset, height } })
}
